import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../auth";

const STATUS_LABEL = {
  pending: "Pending",
  confirmed: "Confirmed",
  paid: "Paid",
  fitting_scheduled: "Fitting Scheduled",
  completed: "Completed",
  refunded: "Refunded",
  cancelled: "Cancelled",
};
const STATUS_COLOR = {
  pending:           { bg: "rgba(255,179,11,0.18)", fg: "#B57E00" },
  confirmed:         { bg: "rgba(61,122,255,0.15)", fg: "#3D7AFF" },
  paid:              { bg: "rgba(0,180,80,0.15)",   fg: "#00A35C" },
  fitting_scheduled: { bg: "rgba(156,80,255,0.15)", fg: "#9C50FF" },
  completed:         { bg: "rgba(0,180,80,0.15)",   fg: "#00A35C" },
  refunded:          { bg: "rgba(255,90,90,0.18)",  fg: "#C32A2A" },
  cancelled:         { bg: "rgba(230,0,0,0.15)",    fg: "var(--primary-red)" },
};

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { adminApi.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div data-testid="admin-orders-page">
      <h1 style={{ fontSize: 28 }}>Orders</h1>
      <p className="vd-muted mb-6">{orders.length} orders to date.</p>
      <div className="vd-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left vd-muted uppercase text-xs tracking-wider border-b" style={{ borderColor: "var(--border-color)" }}>
            <th className="px-4 py-3">Order ID</th><th>Customer</th><th>Items</th><th>Total</th><th>Status</th><th>Date</th><th></th>
          </tr></thead>
          <tbody>
            {loading ? <tr><td colSpan="7" className="px-4 py-8 text-center vd-muted">Loading…</td></tr> :
              orders.length === 0 ? <tr><td colSpan="7" className="px-4 py-8 text-center vd-muted">No orders yet.</td></tr> :
              orders.map((o) => {
                const c = STATUS_COLOR[o.status] || STATUS_COLOR.confirmed;
                return (
                  <tr key={o.id} className="border-t" style={{ borderColor: "var(--border-color)" }} data-testid={`order-row-${o.id}`}>
                    <td className="px-4 py-3 vd-muted text-xs font-mono">#{o.id.slice(0, 8)}</td>
                    <td className="vd-heading font-medium">{o.full_name}</td>
                    <td className="vd-muted">{o.items?.reduce((s, i) => s + (i.quantity || 1), 0)}</td>
                    <td className="vd-heading font-bold" style={{ color: "var(--primary-red)" }}>£{o.total.toFixed(2)}</td>
                    <td><span className="text-xs font-semibold rounded px-2 py-0.5" style={{ background: c.bg, color: c.fg }} data-testid={`order-status-${o.id}`}>{STATUS_LABEL[o.status] || o.status}</span></td>
                    <td className="vd-muted text-xs">{new Date(o.created_at).toLocaleDateString()}</td>
                    <td className="pr-4 text-right"><Link to={`/admin/orders/${o.id}`} className="text-sm font-semibold" style={{ color: "var(--primary-red)" }} data-testid={`order-view-${o.id}`}>View →</Link></td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminOrders;
